import { render, staticRenderFns } from "./ProfileImportModal.vue?vue&type=template&id=98d18b84&scoped=true"
import script from "./ProfileImportModal.vue?vue&type=script&lang=ts"
export * from "./ProfileImportModal.vue?vue&type=script&lang=ts"
import style0 from "./ProfileImportModal.vue?vue&type=style&index=0&id=98d18b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98d18b84",
  null
  
)

export default component.exports